import styled from "styled-components";
import PageTitle from "./PageTitle";
import ArrowedButton from "./ArrowedButton";

const PageHeader = ({
  title,
  buttonText,
  isButtoned = false,
  buttonOnClick,
  subtext,
}: any) => {
  return (
    <Header>
      <TextWrapper>
        <PageTitle title={title} />
        {subtext && <TitleSubText>{subtext}</TitleSubText>}
      </TextWrapper>
      {isButtoned && (
        <ArrowedButton title={buttonText} onClick={buttonOnClick} />
      )}
    </Header>
  );
};

export default PageHeader;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  align-items: center;
  min-height: 44px; //header button width
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TitleSubText = styled.div`
  color: #a3a3a3;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
`;
